export default 'https://tme.understood.org/assets/bundle_1.a7737199.vtt'